import { deleteApi, get, post } from "../GenericServices";

const Wbs = {
  getWbsStructureList: (queryString) => {
    return get(`wbs?${queryString}`);
  },
  wbsStructureData: (id) => {
    return get(`wbs/${id}`);
  },
  saveWbsStructure: (data) => {
    return post("wbs", data);
  },
  deleteWbsStructure: (id) => {
    return deleteApi(`wbs/${id}`);
  },
};

export default Wbs;
